import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

function Lightbox({ isOpen, imageSrc, imageAlt, onClose }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 p-4"
          onClick={onClose}
          data-testid="lightbox-overlay"
        >
          <button
            onClick={onClose}
            className="absolute top-6 right-6 z-10 p-2 text-white hover:bg-white/10 rounded-sm transition-colors"
            aria-label="Close lightbox"
            data-testid="lightbox-close-button"
          >
            <X className="w-8 h-8" strokeWidth={1.5} />
          </button>
          <motion.img
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.25 }}
            src={imageSrc}
            alt={imageAlt}
            className="max-w-full max-h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()}
            data-testid="lightbox-image"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Lightbox;
